import { css } from '@emotion/core'
import theme from 'Theme'
import { smallOnly, mediumUp } from 'Utils'

const { colors } = theme

export default () => {
  return css`
    @media ${smallOnly} {
      overflow: hidden;
      height: 50px;
      .track {
        height: 65px;
        white-space: nowrap;
        overflow-y: hidden;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;

        > .content-filter__button {
          height: 50px;
          display: inline-flex;
          align-items: center;
        }
      }
    }

    @media ${mediumUp} {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .track {
        min-height: 2rem;
      }
    }

    .content-filter__button {
      display: inline-block;
      padding: 0.5rem 1rem;
      color: ${colors.black};
      background-color: #f2f2f2;
      margin-right: 1rem;

      &:hover,
      &.active {
        color: white;
        background-color: black;
      }

      &:last-of-type {
        margin-right: 0;
      }
    }

    .loading-track {
      min-height: 2rem;
    }
  `
}
